// src/dynatrace.js
export function loadDynatrace() {
    //console.info('Dynatrace RUM: loading');
    const dtconfig = process.env.REACT_APP_DTCONFIG;
    if (!dtconfig || !dtconfig.trim()) {

        if (process.env.NODE_ENV !== 'production') {
            console.info('Dynatrace RUM: REACT_APP_DTCONFIG not set (skipping).');
        }
        return;
    }

    const s = document.createElement('script');
    s.src = '/js/ruxitagent.js';
    s.defer = true;
    s.setAttribute('data-dtconfig', dtconfig);

    // s.nonce = window.__CSP_NONCE__;

    document.head.appendChild(s);
}